<template>
	<Component :is="as" :class="variantCls.root" v-on="$listeners"><slot /></Component>
</template>

<script>
export default {
	props: {
		variant: {
			type: String,
			default: "default"
		},

		as: {
			type: String,
			default: () => "p"
		}
	},

	computed: {
		variantCls() {
			return this.$store.getters.variants("JText", this.variant).el
		}
	}
}
</script>
